import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import store from '../store';

const routes = [
  {
    path: '/:pathMatch(.*)*', // Catch-all for undefined routes
    component: () => import('../views/NotFoundView.vue'),
  },
  {
    path: '/',
    meta: { name: 'Index', parent: true },
    component: () => import('../components/Layouts/IndexLayout.vue'),
    children: [
      {
        path: '/login',
        alias: '',
        component: () => import('../views/LoginView.vue'),
        meta: { title: 'Login', ParentName: 'Index'}
      },
      {
        path: '/about',
        alias: '/about',
        component: () => import('../views/AboutView.vue'),
        meta: { title: 'About', ParentName: 'Index'}
      },
      {
        path: '/signup',
        alias: '/signup',
        component: () => import('../views/SignUpView.vue'),
        meta: { title: 'Sign Up', ParentName: 'Index'}
      },
      {
        path: '/reset_password',
        alias: '/reset_password',
        component: () => import('../views/ResetPasswordView.vue'),
        meta: { title: 'Reset Password', ParentName: 'Index'}
      },
    ],
  },
  {
    path: '/home',
    meta: { name: 'Home', parent: true },
    component: () => import('../components/Layouts/DashboardLayout.vue'),
    children: [
      {
        path: '/dashboard',
        alias: '/dashboard',
        component: () => import('../views/UserHomeView.vue'),
        meta: { title: 'Dashboard', ParentName: 'Home'}
      },
      {
        path: '/module',
        alias: '/module',
        component: () => import('../views/ModuleView.vue'),
        meta: { title: 'Module', ParentName: 'Home'}
      },
      {
        path: '/team_list',
        alias: '/team_list',
        component: () => import('../views/TeamListView.vue'),
        meta: { title: 'Team List', ParentName: 'Home'}
      },
      {
        path: '/notifications',
        alias: '/notifications',
        component: () => import('../views/NotificationsView.vue'),
        meta: { title: 'Notifications', ParentName: 'Home'}
      },
      {
        path: '/accreditations_user',
        alias: '/accreditations_user',
        component: () => import('../views/UserAccreditationView.vue'),
        meta: { title: 'Accreditation User', ParentName: 'Home'}
      },
      {
        path: '/psv',
        alias: '/psv',
        component: () => import('../views/PSVView.vue'),
        meta: { title: 'PSV', ParentName: 'Home'}
      },
      {
        path: '/utility_psv',
        alias: '/utility_psv',
        component: () => import('../views/UtilityPSVView.vue'),
        meta: { title: 'Utility PSV', ParentName: 'Home'}
      },
      {
        path: '/utility_level_1',
        alias: '/utility_level_1',
        component: () => import('../views/UtilityLevel1View.vue'),
        meta: { title: 'Utility Level 1', ParentName: 'Home'}
      },
      {
        path: '/utility_level_2',
        alias: '/utility_level_2',
        component: () => import('../views/UtilityLevel2View.vue'),
        meta: { title: 'Utility Level 2', ParentName: 'Home'}
      },
      {
        path: '/utility_level_3_phase_1',
        alias: '/utility_level_3_phase_1',
        component: () => import('../views/UtilityLevel3Phase1View.vue'),
        meta: { title: 'Utility Level 3 Phase 1', ParentName: 'Home'}
      },
      {
        path: '/utility_level_4',
        alias: '/utility_level_4',
        component: () => import('../views/UtilityLevel4View.vue'),
        meta: { title: 'Utility Level 4', ParentName: 'Home'}
      },
      {
        path: '/level_1',
        alias: '/level_1',
        component: () => import('../views/Level1View.vue'),
        meta: { title: 'Level 1', ParentName: 'Home'}
      },
      {
        path: '/level_2',
        alias: '/level_2',
        component: () => import('../views/Level2View.vue'),
        meta: { title: 'Level 2', ParentName: 'Home'}
      },
      {
        path: '/level_3_phase_1',
        alias: '/level_3_phase_1',
        component: () => import('../views/Level3Phase1View.vue'),
        meta: { title: 'Level 3 Phase 1', ParentName: 'Home'}
      },
      {
        path: '/level_3_phase_2',
        alias: '/level_3_phase_2',
        component: () => import('../views/Level3Phase2View.vue'),
        meta: { title: 'Level 3 Phase 2', ParentName: 'Home'}
      },
      {
        path: '/level_4',
        alias: '/level_4',
        component: () => import('../views/Level4View.vue'),
        meta: { title: 'Level 4', ParentName: 'Home'}
      },
      {
        path: '/shared_files',
        alias: '/shared_files',
        component: () => import('../views/SharedFilesView.vue'),
        meta: { title: 'Shared Files', ParentName: 'Home'}
      },
      {
        path: '/summary_rating',
        alias: '/summary_rating',
        component: () => import('../views/SummaryRatingView.vue'),
        props : { showNotification : Function },
        meta: { title: 'Summary Rating', ParentName: 'Home'}
      },
      {
        path: '/areas',
        alias: '/areas',
        component: () => import('../views/AreasView.vue'),
        meta: { title: 'Areas', ParentName: 'Home'}
      },
      {
        path: '/instruments',
        alias: '/instruments',
        component: () => import('../views/InstrumentsView.vue'),
        meta: { title: 'Instruments', ParentName: 'Home'}
      },
      {
        path: '/institutes',
        alias: '/institutes',
        component: () => import('../views/InstitutesView.vue'),
        meta: { title: 'Institutes', ParentName: 'Home'}
      },
      {
        path: '/programs',
        alias: '/programs',
        component: () => import('../views/ProgramsView.vue'),
        meta: { title: 'Programs', ParentName: 'Home'}
      },
      {
        path: '/offices',
        alias: '/offices',
        component: () => import('../views/OfficesView.vue'),
        meta: { title: 'Offices', ParentName: 'Home'}
      },
      {
        path: '/accreditations',
        alias: '/accreditations',
        component: () => import('../views/AccreditationView.vue'),
        meta: { title: 'Accreditations', ParentName: 'Home'}
      },
      {
        path: '/parameters',
        alias: '/parameters',
        component: () => import('../views/ParametersView.vue'),
        meta: { title: 'Parameters', ParentName: 'Home'}
      },
      {
        path: '/assistant_staff_qa',
        alias: '/assistant_staff_qa',
        component: () => import('../views/AssistantStaffQADashboardView.vue'),
        meta: { title: 'Assistant Staaff QA', ParentName: 'Home'}
      },
      {
        path: '/dean',
        alias: '/dean',
        component: () => import('../views/DeanDashboardView.vue'),
        meta: { title: 'Institute Dean', ParentName: 'Home'}
      },
      {
        path: '/director_qa',
        alias: '/director_qa',
        component: () => import('../views/DirectorQADashboardView.vue'),
        meta: { title: 'Director QA', ParentName: 'Home'}
      },
      {
        path: '/external_accreditor',
        alias: '/external_accreditor',
        component: () => import('../views/ExternalDashboardView.vue'),
        meta: { title: 'External Accreditor', ParentName: 'Home'}
      },
      {
        path: '/internal_accreditor',
        alias: '/internal_accreditor',
        component: () => import('../views/InternalDashboardView.vue'),
        meta: { title: 'Internal Accreditor', ParentName: 'Home'}
      },
      {
        path: '/head_director',
        alias: '/head_director',
        component: () => import('../views/HeadDirectorDashboardView.vue'),
        meta: { title: 'Head Director', ParentName: 'Home'}
      },
      {
        path: '/program_chair',
        alias: '/program_chair',
        component: () => import('../views/ProgramChairDashboardView.vue'),
        meta: { title: 'Program Chair', ParentName: 'Home'}
      },
      {
        path: '/task_force',
        alias: '/task_force',
        component: () => import('../views/TaskForceDashboardView.vue'),
        meta: { title: 'Task Force', ParentName: 'Home'}
      },
      {
        path: '/accounts',
        alias: '/accounts',
        component: () => import('../views/AccountsView.vue'),
        meta: { title: 'Accounts', ParentName: 'Home'}
      },
      {
        path: '/profile',
        alias: '/profile',
        component: () => import('../views/ProfileView.vue'),
        meta: { title: 'Profile', ParentName: 'Home'}
      },
      {
        path: '/settings',
        alias: '/settings',
        component: () => import('../views/SettingsView.vue'),
        meta: { title: 'Settings', ParentName: 'Home'}
      },
      {
        path: '/announcements',
        alias: '/announcements',
        component: () => import('../views/AnnouncementsView.vue'),
        meta: { title: 'Announcements', ParentName: 'Home'}
      },
      {
        path: '/trash',
        alias: '/trash',
        component: () => import('../views/TrashView.vue'),
        meta: { title: 'Trash', ParentName: 'Home'}
      },
      {
        path: '/evidence',
        alias: '/evidence',
        component: () => import('../views/ViewEvidence.vue'),
        meta: { title: 'Evidence', ParentName: 'Home'}
      },
      {
        path: '/menu_list',
        alias: '/menu_list',
        component: () => import('../views/UtilityUserMenuView.vue'),
        meta: { title: 'Utility User Menu List', ParentName: 'Home'}
      },
      {
        path: '/assign_user_menu',
        alias: '/assign_user_menu',
        component: () => import('../views/AssignUserTypeMenuView.vue'),
        meta: { title: 'Utility Assign User Type Menu', ParentName: 'Home'}
      },
      {
        path: '/references',
        alias: '/references',
        component: () => import('../views/ReferencesView.vue'),
        meta: { title: 'References', ParentName: 'Home'}
      },
      {
        path: '/institutional-accreditation',
        alias: '/institutional-accreditation',
        component: () => import('../views/InsitutionalAccreditationView.vue'),
        meta: { title: 'Institutional Accreditation', ParentName: 'Home'}
      },
      {
        path: '/template-institutional-accreditation',
        alias: '/template-institutional-accreditation',
        component: () => import('../views/UtilityIAIndicators.vue'),
        meta: { title: 'Template Institutional Accreditation Indicators', ParentName: 'Home'}
      },
      {
        path: '/calendar',
        alias: '/calendar',
        component: () => import('../views/CalendarView.vue'),
        meta: { title: 'Calendar', ParentName: 'Home'}
      },
      {
        path: '/ia-instruments',
        alias: '/ia-instruments',
        component: () => import('../views/IAInstrumentsView.vue'),
        meta: { title: 'Institutional Instruments', ParentName: 'Home'}
      },
      {
        path: '/ia-areas',
        alias: '/ia-areas',
        component: () => import('../views/IAAreasView.vue'),
        meta: { title: 'Institutional Areas', ParentName: 'Home'}
      },
    ]
  }
  
]
const DEFAULT_TITLE = 'AKRED';
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
// router.afterEach((to) => {
//   nextTick(() => {
//     if( to.meta && to.meta.title != ''   ) document.title = "AKRED - " + to.meta.title;
//     else document.title = DEFAULT_TITLE; 
//   });
// });
router.beforeEach((to, from, next) => {
  let role = store.state.user;
  if (to.matched.some(record => record.meta.Home)) {
      if (!role) {
          next({ path: '/'})
      } else {
        document.title = "AKRED - " + to.meta.title;
        next()
      }
  }
  else {
    document.title = "AKRED - " + to.meta.title;
      next()
  }
})

export default router

